import React from "react";
import PopupCommon from "../PopupCommon";

const PopupTaxInfo = (props) => {
  const { popupTaxInfo, setpopupTaxInfo } = props;

  const restaurantServiceTaxData = [
    {
      name: "Food supplied or catering services by Indian Railways/IRCTC",
      value: "5% without ITC",
    },
    {
      name: "Standalone restaurants, including takeaway (both air-conditioned and non a/c)",
      value: "5% without ITC",
    },
    {
      name: "Standalone outdoor catering services or food delivery service",
      value: "5% without ITC",
    },
    {
      name: "Restaurants within hotels (Where room tariff is less than Rs 7,500)",
      value: "5% without ITC",
    },
    {
      name: "Normal/composite outdoor catering within hotels (Where room tariff is less than Rs 7,500)",
      value: "5% without ITC",
    },
    {
      name: "Restaurants within hotels* (Where room tariff is more than or equal to Rs 7,500)",
      value: "18% with ITC",
    },
    {
      name: "Normal/composite outdoor catering within hotels* (Where room tariff is more than or equal to Rs 7,500)",
      value: "18% with ITC",
    },
  ];

  const foodItemsTaxData = [
    {
      name: "GST on fresh and chilled vegetables including potatoes, onions, garlic, leek etc.",
      value: "NIL",
    },
    {
      name: "GST on non-container packed dried leguminous vegetables(shelled) whether skinned/split or not",
      value: "NIL",
    },
    {
      name: "GST on fresh grapes, fresh/dried coconut, fresh/dried bananas/plantain, fresh apples, fresh pears, etc.",
      value: "NIL",
    },
    {
      name: "GST on meat (not in container whether fresh or chilled)",
      value: "NIL",
    },
    {
      name: "GST on birds’ eggs in shell (fresh/cooked/preserved)",
      value: "NIL",
    },
    {
      name: "GST on unsweetened milk (pasteurised/unpasteurised), cream, etc.",
      value: "NIL",
    },
    {
      name: "GST on container packed vegetables (uncooked/steamed/boiled)",
      value: "NIL",
    },
    {
      name: "GST on vegetables preserved using brine/other means unsuitable for immediate human consumption",
      value: "NIL",
    },
    {
      name: " GST on meat packed in container bearing registered trademark/brand name",
      value: "5% GST",
    },
    {
      name: "GST on birds’ eggs not in shell/egg yolks boiled or cooked by steaming",
      value: "5% GST",
    },
    {
      name: "GST on dried leguminous vegetables packed in container bearing registered brand name (skinned/split or not)",
      value: "5% GST",
    },
    {
      name: "GST on ginger (excluding fresh ginger), turmeric (excluding fresh turmeric), thyme, curry leaves, bay leaves, etc.",
      value: "5% GST",
    },
    {
      name: "GST on food such as meal/powder of dried leguminous vegetables",
      value: "5% GST",
    },
    {
      name: "GST on vegetables, fruits, nuts and edible plant parts preserved using sugar",
      value: "12% GST",
    },
    {
      name: "GST on vegetables, fruits, nuts and edible plant parts that are preserved/prepared using vinegar/acetic acid.",
      value: "12% GST",
    },
    {
      name: "GST on food preparations such as those prepared using flour, malt extract, etc. containing cocoa less than 40% of total weight.",
      value: "18% GST",
    },
    {
      name: "GST on chocolate and other cocoa products",
      value: "18% GST",
    },
  ];

  return (
    <PopupCommon className="popupp-tax-info" onClickFalse={() => setpopupTaxInfo(false)} isVisible={popupTaxInfo}>
      <h3 className="mb-3 grey">Here’s a breakdown of the GST Rate on Restaurant Services:</h3>

      {restaurantServiceTaxData.map((item, i) => (
        <div
          key={item.name}
          className={`flex-jb-ac g-2 ${i === restaurantServiceTaxData.length - 1 ? "mb-5" : "mb-2"}`}
        >
          <p>{item.name}</p>
          <p style={{ width: "12rem", flexShrink: 0 }}>{item.value}</p>
        </div>
      ))}

      <h3 className="mb-3 grey">GST on Food Items:</h3>

      {foodItemsTaxData.map((item, i) => (
        <div key={item.name} className={`flex-jb-ac g-2 ${i === foodItemsTaxData.length - 1 ? "" : "mb-2"}`}>
          <p>{item.name}</p>
          <p style={{ width: "12rem", flexShrink: 0 }}>{item.value}</p>
        </div>
      ))}
    </PopupCommon>
  );
};

export default PopupTaxInfo;
